import styled from 'styled-components';
import {
  Container as SemanticContainer,
  Menu as SemanticMenu,
} from 'semantic-ui-react';

import { Header as TextHeader, Text as TextLayoutComponent } from '@playbookux/playbook-web-core';
import SelectionDropdownMulti from '../../../core/components/multi-selection-dropdown';
import SearchInput from '../../../core/layout-components/search';

const Container = styled(SemanticContainer)`
  margin-top: 80px;
  padding-left: 30px;
  &&& {
    @media only screen and (min-width: 1200px) {
      width: 1190px;
    }
  }
`;

const TitleContainer = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 20px;
`;

const FilterContainer = styled.div`
  display: flex;
  flex-grow: 1;
`;

const SearchField = styled(SearchInput).attrs({
  width: '100%',
})``;

const MultiSelectionDropdown = styled(SelectionDropdownMulti).attrs({
  height: '38px',
})``;

const MenuContainer = styled.div`
  margin-left: 5px;
`;

const MenuFilter = styled(SemanticMenu)``;

const MenuFilterItem = styled(MenuFilter.Item)`
 &&&&&& {
    color: ${({ theme }) => theme.color.textSecondary};
    font-size: ${({ theme }) => theme.fontSize.textHeader};
    font-family: roboto;
    padding: .6em;
    margin: 0;
    margin-right: 0.25em;
    &.active.item {
      background: rgba(240,244,251);
    }
    :hover {
      background: rgba(240,244,251);
    }
  }
`;

const Center = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 80px;
`;

const CardsContainer = styled.div``;

const ContainerDropdown = styled.div`
  width: 300px;
  margin-left: 20px;
`;

const ZeroState = styled.div`
  display: flex;
  margin-top: 100px;
  align-items: center;
  flex-direction: column;
`;

const NoResultFind = styled.div`
  display: flex;
  margin-top: 150px;
  align-items: center;
  flex-direction: column;
`;

const Text = styled(TextHeader)`
  margin: 0;
`;

const Message = styled(TextLayoutComponent)`
  margin-top: 10px;
  font-size: 16px;

  width: ${({ fluid }) => (fluid ? '100%' : '400px')}
  & {
    text-align: center;
  }
`;

const SearchImgIcon = styled.img`
  margin-bottom: 25px;
`;

export {
  Container,
  MultiSelectionDropdown,
  FilterContainer,
  SearchField,
  TitleContainer,
  MenuContainer,
  MenuFilter,
  MenuFilterItem,
  Center,
  CardsContainer,
  ContainerDropdown,
  ZeroState,
  Text,
  Message,
  SearchImgIcon,
  NoResultFind,
};
